const defaultTeams = {
  mar: "Marruecos",
  sen: "Senegal",
  tun: "Túnez",
  ksa: "A. Saudita",
  aus: "Australia",
  jpn: "Japón",
  kor: "Corea",
  irn: "Irán",
  ger: "Alemania",
  bel: "Bélgica",
  cro: "Croacia",
  den: "Dinamarca",
  esp: "España",
  fra: "Francia",
  eng: "Inglaterra",
  pol: "Polonia",
  por: "Portugal",
  srb: "Serbia",
  sui: "Suiza",
  crc: "Costa Rica",
  mex: "México",
  arg: "Argentina",
  bra: "Brasil",
  uru: "Uruguay",
  can: "Canada",
  cmr: "Camerún",
  ecu: "Ecuador",
  gha: "Ghana",
  ned: "Países Bajos",
  qat: "Qatar",
  usa: "Estados Unidos",
  wal: "Gales",
};

export default (state = defaultTeams, action = {}) => {
  if (action.type === "TEAMS_MERGE" && action.payload) {
    return { ...state, ...action.payload };
  }
  return state;
};
